import * as React from 'react';
import { useCallback, useState } from 'react';
import { AutocompleteRenderInputParams } from '@mui/material';

import { AutocompleteOption } from '../../Dropdown/types';
import { clearPhone, formatPhone } from '../../PhoneInput/utils';
import Dropdown, { Props as DropdownProps } from '../../Dropdown/components/Dropdown';
import Input from '../../Input';

export type PhoneDropdownProps = Omit<DropdownProps, 'options' | 'renderInput' | 'onChange' | 'onInputChange'> & {
	options: string[];
	onChange?: (value: string) => void;
	onInputChange?: (value: string) => void;
};

const PhoneDropdown: React.FC<PhoneDropdownProps> = ({ options, InputProps, onChange, onInputChange, ...props }) => {
	const [value, setValue] = useState(props.value || '');

	const renderInput = useCallback((params: AutocompleteRenderInputParams) => <Input {...params} {...InputProps} />, [
		InputProps
	]);

	const onChangeHandler = (_: React.SyntheticEvent, value: string | AutocompleteOption) => {
		onChange(typeof value === 'string' ? value : value.value);
	};

	const onInputChangeHandler = (_: React.SyntheticEvent, newValue: string) => {
		const phoneValue = formatPhone(newValue);

		if (value !== phoneValue) {
			setValue(formatPhone(phoneValue));
			onInputChange?.(clearPhone(newValue));
		}
	};

	return (
		<Dropdown
			freeSolo
			forcePopupIcon
			disableClearable
			renderInput={renderInput}
			inputValue={value as string}
			options={options.map(value => ({ label: formatPhone(value), value }))}
			onChange={onChangeHandler}
			onInputChange={onInputChangeHandler}
			{...props}
		/>
	);
};

export default PhoneDropdown;
